import { useEffect } from "react";
import { COPY_STRINGS } from "../../../../constants/translatedCopy";

export default function useNetworkSpeedError({currentError, speechProps}){

    useEffect(()=>{
        // optionally handle each currentError individually
        if(currentError){
            // Amira speech and gesture.
            speechProps.speak({
                textToSpeak: COPY_STRINGS.student_checks.network_speed_error_one + COPY_STRINGS.student_checks.network_speed_error_two,
            })
        }
    }, [currentError])
}